module.exports = __webpack_public_path__ + "static/media/1_pl.e8571217.png";